const MEDIA_VIEW_SUBJECT = /\b(front|back|rear|side|profile|bicep|posterior|chest|shoulder|arm|torso|leg|legs|quad|hamstring|calf|lower body|full[- ]body|head to toe|feet visible|entire body|pose|poses|view)\b/i;

// Legacy records used one flat list. Only deliberately recognized
// cross-cutting rules move out of the photo inventory; unknown text remains a
// view so old evidence requirements cannot disappear through guesswork.
export const mediaGlobalConstraintKey = (value) => {
  const text = String(value || '').trim();
  if (!text || MEDIA_VIEW_SUBJECT.test(text)) return '';
  if (/\b(hairless|body\s*hair|groom(?:ing|ed)?)\b/i.test(text)) return 'grooming';
  if (/\b(consistent|same|matching|even)\s+(lighting|exposure)\b|\blighting\s+and\s+exposure\b/i.test(text)) return 'lighting';
  return '';
};

export const splitMediaRequirementItems = (items) => (Array.isArray(items) ? items : []).reduce((result, item) => {
  const value = String(item || '').trim();
  if (!value) return result;
  if (mediaGlobalConstraintKey(value)) result.globalConstraints.push(value);
  else result.views.push(value);
  return result;
}, { views: [], globalConstraints: [] });

export const mergeMediaGlobalConstraints = (...lists) => {
  const seen = new Set();
  return lists.flatMap(list => Array.isArray(list) ? list : []).filter(item => {
    const value = String(item || '').trim();
    const key = mediaGlobalConstraintKey(value) || value.toLowerCase().replace(/\s+/g, ' ');
    if (!value || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const resolveMediaRequirementContract = (data = {}) => {
  const legacy = splitMediaRequirementItems(data?.requirements);
  return {
    views: legacy.views,
    globalConstraints: mergeMediaGlobalConstraints(legacy.globalConstraints, data?.global_constraints)
  };
};
